import React, { Component } from "react";
import { Input, message, Row, Col, Upload, Tag, Space, notification, Spin } from "antd";
import { Form, FormItem, ButtonItem, ErrorItem } from "../../../../Components/Items";
import axios from "axios";
import { connect } from "react-redux";
import {
  UploadOutlined,
  LockOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined
} from "@ant-design/icons";
import moment from "moment"
import DescargaMasivaConfiguracion from "../DescargaMasivaConfiguracion/DescargaMasivaConfiguracion";

import DynamicCardForm from "../../../../Components/DynamicCardForm";

class FiscalConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    archivosCertificado: [],
    archivoCertificado: [],
    archivosLlavePrivada: [],
    archivoLlavePrivada: [],
    llavePrivada: false,
    certificado: false,
    passwordSAT: false,
    fechaVencimiento: null,
    loading: false
  };
  componentDidMount() {
    this.consultarConfiguracion();
  }
  onFinish(values) {
    let fd = new FormData();
    fd.append("empresaId", this.props.empresaId);
    for (var key in values) {
      if (values[key] !== null) {
        fd.append(key, values[key]);
      }
    }
    if (this.state.archivoLlavePrivada) {
      fd.append("llavePrivada", this.state.archivoLlavePrivada);
    }
    if (this.state.archivoCertificado) {
      fd.append("certificado", this.state.archivoCertificado);
    }
    axios
      .post("empresas/editarConfiguracionFiscal", fd, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuracion de la empresa");
          message.success("Sus certificados fueron validados")
          this.consultarConfiguracion();
        } else if (res.data.success === 1) {
          message.error("Los certificados se subieron pero no fueron validados");
          notification.error({
            message: 'Error',
            description: res.data.message,
            duration: null
          })
        } else {
          message.error(res.data.message || "Hubo un error y no se modifico la configuracion");
        }
      });
  }
  async consultarConfiguracion() {
    this.setState({ loading: true })
    await axios
      .post(
        "empresas/selectConfiguracionFiscal",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro configuracion de esta empresa");
        } else {
          this.setState({
            llavePrivada: !!res.data.llavePrivada,
            certificado: !!res.data.certificado,
            passwordSAT: !!res.data.passwordSAT,
            fechaVencimiento: res.data.fechaVencimientoCSD
              ? moment(res.data.fechaVencimientoCSD).format("DD/MM/YYYY")
              : null,
          });
        }
      });
    this.setState({ loading: false })
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  async onChangeArchivoCertificado(e) {
    if (e.file.type === "application/x-x509-ca-cert") {
      this.setState({ archivosCertificado: [e.file], archivoCertificado: e.file });
    } else {
      message.error("El archivo debe ser de tipo .cer");
    }
  }
  async onChangeArchivoLlavePrivada(e) {
    if (e.file.name.split('.').pop() === "key") {
      this.setState({ archivosLlavePrivada: [e.file], archivoLlavePrivada: e.file });
    } else {
      message.error("El archivo debe ser de tipo .key");
    }
  }
  render() {
    return (
      <>
        <Spin spinning={this.state.loading}>
          <DynamicCardForm
            title="Fiscal (CSD)"
            style={{
              maxWidth: '98%',
              margin: '0 auto'
            }}
          >
            <Form
              name="fiscalConfiguracion"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
              ref={this.formRef}
            >
              <Row>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <FormItem
                    label="Fecha de vencimiento:"
                    colon={false}
                    margin
                  >
                    <span>{this.state.fechaVencimiento}</span>
                  </FormItem>
                  <FormItem
                    name="passwordSAT"
                    margin
                    label="Contraseña SAT"
                    pattern
                    required
                  >
                    <Space>
                      <Input.Password
                        placeholder="Se remplazara al guardar"
                        prefix={<LockOutlined className="site-form-item-icon" />}
                      />
                      {this.state.passwordSAT ? (
                        <Tag color="success" icon={<CheckOutlined />}>
                          Subido
                        </Tag>
                      ) : (
                        <Tag color="error" icon={<ExclamationCircleOutlined />}>
                          Faltante
                        </Tag>
                      )}
                    </Space>
                  </FormItem>
                  <FormItem required margin name="certificado" label="Certificado (.cer)">
                    <Upload
                      accept=".cer"
                      showUploadList={{
                        showRemoveIcon: false,
                        showPreviewIcon: false,
                      }}
                      fileList={this.state.archivosCertificado}
                      customRequest={this.onChangeArchivoCertificado.bind(this)}
                    >
                      <Space>
                        <ButtonItem blanco icon={<UploadOutlined />}>Subir</ButtonItem>
                        {this.state.certificado ? (
                          <Tag color="success" icon={<CheckOutlined />}>
                            Subido
                          </Tag>
                        ) : (
                          <Tag color="error" icon={<ExclamationCircleOutlined />}>
                            Faltante
                          </Tag>
                        )}
                      </Space>
                    </Upload>
                  </FormItem>
                  <FormItem required margin name="llavePrivada" label="Clave privada (.key)">
                    <Upload
                      accept=".key"
                      showUploadList={{
                        showRemoveIcon: false,
                        showPreviewIcon: false,
                      }}
                      fileList={this.state.archivosLlavePrivada}
                      customRequest={this.onChangeArchivoLlavePrivada.bind(this)}
                    >
                      <Space>
                        <ButtonItem blanco icon={<UploadOutlined />}>Subir</ButtonItem>
                        {this.state.llavePrivada ? (
                          <Tag color="success" icon={<CheckOutlined />}>
                            Subido
                          </Tag>
                        ) : (
                          <Tag color="error" icon={<ExclamationCircleOutlined />}>
                            Faltante
                          </Tag>
                        )}
                      </Space>
                    </Upload>
                  </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginTop: 16 }}>
                  <div
                    style={{
                      background: '#f7f9fa',
                      padding: '20px',
                      borderRadius: '8px',
                      height: '50%',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <div>
                      <p style={{ marginBottom: 0, lineHeight: 1.8 }}>
                        <InfoCircleOutlined style={{ marginRight: 8 }} />
                        Estos documentos seran procesados por nosotros para ofrecer el sistema de timbrado, comuníquese con nosotros si no se ha completado
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
              <ButtonItem
                cyan
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto", minWidth: 120, height: 30, }}
              >
                Guardar Configuración
              </ButtonItem>

            </Form>
          </DynamicCardForm>
        </Spin>
        <DescargaMasivaConfiguracion />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(FiscalConfiguracion);
